import Vue from 'vue';
import Router from 'vue-router';
// import HelloWorld from '@/components/HelloWorld'
import indexPage from '@/components/index';
import error from '@/components/404Page';
import logRouter from '@/components/login/loginRouter';
import loginPage from '@/components/login/login';
import registerPage from '@/components/login/register';
import infoService from '@/components/detailPage/infoService';
import companyIntroduce from '@/components/companyIntroduce/introduce';
import successExample from '@/components/successExample/example';
import cooperation from '@/components/cooperation/cooperation';

Vue.use(Router);

export default new Router({
    // mode:"history",
    routes: [
        {
            path: '/',
            redirect: "indexPage",
            component: indexPage
        },
        {
            path: '*',
            redirect: "/404"
        },
        {
            path: '/404',
            component: error
        },
        {
            path: '/indexPage',
            name: 'indexPage',
            component: indexPage,
            children: [
            ]
        },
        {
            path: '/infoService',
            name: 'infoService',
            component: infoService
        },
        {
            path: '/companyIntroduce',
            name: 'companyIntroduce',
            component: companyIntroduce
        },
        {
            path: '/cooperation',
            name: 'cooperation',
            component: cooperation
        },
        {
            path: '/successExample',
            name: 'successExample',
            component: successExample
        },
        {
            path: '/logRouter',
            name: 'logRouter',
            component: logRouter,
            redirect:"/registerPage",
            children:[
                {
                    path: '/login',
                    name: 'loginPage',
                    component: loginPage
                },
                {
                    path: '/registerPage',
                    name: 'registerPage',
                    component: registerPage
                }
            ]
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js